import { Heading } from "@components/typography"
import { Container, FlexBox } from "@components/wrapper"
import { HARISENIN_PUBLIC_PAGE_ASSETS } from "@constants/const/pictures"
import clsx from "clsx"
import Image from "next/image"
import React from "react"

export const HelpCta = () => {
  const contactUs = () => {
    const section = (document.getElementById("#contactUs") as HTMLElement) || null
    section.scrollIntoView({ behavior: "smooth", block: "start" })
  }

  return (
    <Container className="sm:mb-15 mb-10">
      <div className="relative">
        <Image
          loading="lazy"
          src={`${HARISENIN_PUBLIC_PAGE_ASSETS}/corporate_cta.png`}
          alt="banner-1"
          className="fade_in_left object-cover -z-20 h-full"
          layout="fill"
        />
        <div
          className={clsx(
            "flex sm:bg-gradient-to-r sm:from-[rgba(0,0,0,0.6)] sm:via-[rgba(0,0,0,0.3)] z-50 sm:h-[330px]",
            "bg-black/[45%] h-[50vw] w-full"
          )}
        >
          <FlexBox className="wh-full my-auto text-center md:text-left sm:px-15">
            <div className="my-auto sm-only:w-full">
              <Heading
                headingLevel="banner-non-h1"
                className={clsx(
                  "text-white w-3/4 sm:mb-8",
                  "sm-only:leading-6 sm-only:mx-auto mb-4"
                )}
              >
                Butuh Bantuan? Hubungi Kami Sekarang!
              </Heading>

              <button
                onClick={contactUs}
                className={clsx(
                  "text-white  sm:bg-green sm:py-3 sm:w-1/3 sm:text-sm font-semibold",
                  "px-4 py-2 bg-blue w-2/5 text-xs"
                )}
              >
                Hubungi Kami
              </button>
            </div>
          </FlexBox>
        </div>
      </div>
    </Container>
  )
}
